var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Products"},[_c('div',{staticClass:"hero simple",staticStyle:{"background-image":"url('/static/leeno/events_first_bg.jpg')"}},[_c('div',{staticClass:"content"},[_c('h1',{staticClass:"hero-title"},[_vm._v(_vm._s(_vm.$t('messages.terms')))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c874448","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/firstLevel/Terms.vue
// module id = null
// module chunks = 